import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Hotels'

export const HotelsEP : EndPointConfig[] =[
    new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetHotels")
]